import templateUrl from "./show-remaining-chars.html";

export const showRemainingCharsComponent = {
  bindings: {
    maxChars: "@",
    text: "<",
  },
  templateUrl,
  controller: class ShowRemainingChars {
    $onInit() {}
    getRemainingCharacters(value, limit) {
      if (value && value.length <= limit) {
        return limit - value.length;
      } else if (value && value.length >= limit) {
        return 0;
      } else {
        return limit;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/common/components/show-remaining-chars/show-remaining-chars.component.js